module.exports = __webpack_public_path__ + "img/arrowOrange.f5dd7d92.svg";